<template>
    <div class="default-main ba-table-box">
        <!-- 表格顶部菜单 -->
        <buttons :buttons="['columnDisplay']" :access="['']" :tableData="tableData"  ></buttons>

        <!-- 表格 -->
        <tables :tableData="tableData" :tableKey="$options.name" ></tables>

    </div>
</template>

<script>
    import buttons from '@/components/buttons.vue'
    import tables from '@/components/tables.vue'
    import dialogForm from '@/components/dialogForm.vue'
    import dialogTable from '@/components/dialogTable.vue'

    export default {
        name: "momentBuyList",
        components:{
            buttons,
            tables,
            dialogForm,
            dialogTable,
        },
        data() {
            return {
                //region table数据
                tableData:{
                    form: {
                        page: 1,             //页数
                        limit: this.$tools.getLimit(this.$options.name), //条数
                        total: 0,               //总数
                    },
                    column: [
                        { type: 'index' },
                        { label: "充值时间", prop: 'createDateTime', type: 'time', show:true, condition:"dates"},
                        { label: "充值金额", prop: 'price', type: 'text', show:true,  },
                        { label: "充值人", prop: 'userName', type: 'text', show:true, },
                    ],
                    currRow: {},
                    data: [],
                    searchClick: res => {
                        this.searchClick();
                    },
                },
                //endregion
            }
        },
        methods: {

            /**
             * 查询数据
             */
            searchClick(){
                let param = JSON.parse(JSON.stringify(this.tableData.form));
                const createDateTime = this.tableData.form.createDateTime;
                delete param.createDateTime;
                delete param.startDateTime;
                delete param.endDateTime;
                if(createDateTime && createDateTime.length == 2){
                    param.startDateTime = this.$dayjs(createDateTime[0]).format('YYYY-MM-DD') + " 00:00:00";
                    param.endDateTime = this.$dayjs(createDateTime[1]).format('YYYY-MM-DD') + " 23:59:59";
                }

                param.configName = param.packagesConfigName;
                param.companyId = this.$store.state.companyInfo.companyId;
                param.shopId = this.$store.state.shopInfo.id;
                this.$POST("/customer/EomsOssOrder/own/page", param).then(res => {
                    for (let i = 0; i < res.data.records.length; i++) {
                        res.data.records[i].price = this.$tools.accDiv(res.data.records[i].price, 100) + '元'
                    }
                    this.tableData.data = res.data.records;
                    this.tableData.form.total = res.data.total
                })
            },

        },
        mounted() {
        },

        activated() {
            //初始查询
            this.searchClick();
        }
    }
</script>

<style scoped>

</style>
